var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group position-relative m-0" }, [
    _vm.label
      ? _c("label", { staticClass: "font-size-12" }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.iValue,
          expression: "iValue",
        },
      ],
      ref: "inputValue",
      staticClass: "form-control",
      style: _vm.inputStyle,
      attrs: { type: "text", placeholder: _vm.placeholder },
      domProps: { value: _vm.iValue },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.iValue = $event.target.value
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }